import React from "react"
import "./style.scss"
// import bannerImage from "../../../images/homepage_banner.png"
import hash from "../../../images/banners/hash1.png"
import werselSlide from "../../../images/banners/wersel-slide.png"
import capture from "../../../images/homePage_banner/homepage-banner-desk.png"
import captureMob from "../../../images/homePage_banner/homepage-banner-mob.png"
import newbanner from "../../../images/homePage_banner/NewBanner.png"
import banner from "../../../images/banner.gif"
import bannerMob from "../../../images/bannerMob.gif"
import { makeStyles, useTheme, Button, Card, CardContent, CardMedia, Typography } from '@material-ui/core'
import { navigate } from "gatsby"
import icon1 from "../../../images/homePage_banner/card/icon1.png"
import icon2 from "../../../images/homePage_banner/card/icon2.png"
import icon3 from "../../../images/homePage_banner/card/icon3.png"
import icon4 from "../../../images/homePage_banner/card/icon4.png"
import icon5 from "../../../images/homePage_banner/card/icon5.png"


const useStyles = makeStyles((theme)=>({
  bannerContent: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up(576)]: {
      justifyContent: 'center',
      marginLeft: '5%',    
    },
    [theme.breakpoints.down(576)]: {
      justifyContent: 'end',
      marginLeft: 'auto',  
      marginRight: '5%',  
      marginBottom: '4%',
    },
  },
  content: {
    color: 'white',
  },
  wordContent: {
    fontWeight: 'bold',
    fontFamily: 'sans-serif !important',
    [theme.breakpoints.up(900)]: {
      fontSize: '30px',
    },
    [theme.breakpoints.down(900)]: {
      fontSize: '19px',
    },
  },
  spanContent: {
    fontWeight: 'bold',
    fontFamily: 'sans-serif !important',
    fontStyle: 'italic',
    [theme.breakpoints.up(900)]: {
      fontSize: '40px',
    },
    [theme.breakpoints.down(900)]: {
      fontSize: '26px',
    },
  },
  requestDemoBtn: {
    borderRadius: '6.4225px',
    borderWidth: 'thin',
    borderColor: 'white',
    textTransform: 'none',
    color: '#FFFFFF',
    [theme.breakpoints.down(900)]: {
      fontSize: '14px',
    },
  },
  learnBtn: {
    borderRadius: '6.4225px',
    background: 'linear-gradient(108deg, rgba(0,80,127,1) 0%, rgba(21,176,154,1) 100%);',
    textTransform: 'none',
    color: '#FFFFFF',
    [theme.breakpoints.down(900)]: {
      fontSize: '14px',
    },
  },
  bannerCard: {
    background: 'linear-gradient(108deg, rgba(0,80,127,1) 0%, rgba(21,176,154,1) 100%);',
    display: 'flex',
    justifyContent: 'center',
    maxWidth: 'fit-content',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '-38px',
    position: 'relative',
    overflow: 'visible',
  },
  iconImg: {
    height: 'max-content',
    marginBottom: '0rem',
    // paddingTop: '10px',
    // paddingBottom: '10px',
  },
  Card: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down(900)]: {
      display: 'none',
    },
  },
}))

const BannerSection = ({ bannerImg, bannerBG }) => {
  const classes = useStyles()
  const theme = useTheme()

  const sectionData = {
    tags: [
      {
        name: `Learn with \nWersel`,
        image: icon5,
      },
      {
        name: `Collaborative \nAnalytics`,
        image: icon1,
      },
      {
        name: `Blockchain \nEncryption`,
        image: icon2,
      },      
      {
        name: `DataOps \nMLOps`,
        image: icon3,
      },     
      {
        name: `Poeple and AI \nAnalytics`,
        image: icon4,
      },      
    ],
  }

  const { tags } = sectionData

  return (
    <div className="homepageBanner">
      {/* <div className="bannerContainer">
        <img src={bannerImage} alt="bannerImage" />
        <div className="bannerHeader">
          <h1 className="bannerTitle">Find true power In your data.</h1>
          <p className="bannerSubTitle">
            Wesel is a powerful brand collaborative and analytics platform can
            access your scattered data from every channel, collect and normalize
            it
          </p>
        </div>
      </div> */}
      {/* <div class="container-fluid">
        <div class="row">
          <div class="image-text-overlay text-middle-left col-sm-6 col-md-12">
            <p>
              <span class="overlay-title">middle left</span>
              <br></br>
              <span class="overlay-subtext">This is subtext.</span>
            </p>
          </div>
        </div>
      </div> */}

      <div className="container-fluid bannerContainer">
        {/* <div className="bannerImage">
          <img src={bannerImg} alt="bannerImage" />
        </div> */}
        <div
          className="row bannerRow"
          style={{
            background: `url(${newbanner})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
        >
          <div className={classes.bannerContent}>
            <div className={classes.content}>
              {/* <img className="bannerImage" src={newbanner} alt='img' />
              <img className="bannerImageMob" src={newbanner} alt='img' /> */}
              <p className={classes.wordContent}>Stay Ahead in the <br/><span className={classes.spanContent}>Data Revolution</span> with<br/><span className={classes.spanContent}>Wersel Workdesk</span></p>
            </div>
            <div  className={classes.btn}>
            <Button className={classes.learnBtn} variant="contained"  onClick={()=> navigate(`https://wersel.world/learn/`)}>Learn</Button>&nbsp;&nbsp;&nbsp;
            <Button className={classes.requestDemoBtn} variant="outlined" onClick={()=> navigate(`https://wersel.world/learn/`)}>Course Registration</Button>
            </div>
          </div>
          {/* <div className="bannerHeader col-sm-5	col-md-5	col-lg-5">
            <div className="bannerImage">
            <img src={werselSlide} alt="bannerImage" />
            </div>
          </div> */}
          {/* <div className="rowBannerImage col-sm-7	col-md-7	col-lg-7">
            <img src={hash} alt="rowBannerImage" />
            <p className="bannerTitle">
              <span style={{ color: '#65B180' }}>Success</span> requires sharing the right data to the<br/> right person at the right time.
            </p>
          </div> */}
        </div>
      </div>
      <div className={classes.Card}>
        <Card className={classes.bannerCard}>
        {tags &&
          tags.map((tag, index) => (
          <div key={index} style={{ display: 'flex', padding: '0px 10px', alignItems: 'center' }}>
          <img src={tag.image} alt='icon' className={classes.iconImg}/>
          <CardContent style={{ color: 'white', whiteSpace: 'pre-wrap', lineHeight: 'normal', fontSize: '15px', fontFamily: 'sans-serif', fontWeight: 'bold' }}>{tag.name}</CardContent>
          </div>
          ))
        }
        </Card>
      </div>
      <div className="scrollContainer">
        <div className="chevron"></div>
        <div className="chevron"></div>
        <div className="chevron"></div>
        <p className="text">Scroll Down</p>
      </div>
    </div>
  )
}

export default BannerSection
